import React, { useEffect, useState } from 'react';

const ClockWidget = ({ config }) => {
    const { settings = {} } = config;
    const [now, setNow] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => setNow(new Date()), 1000);
        return () => clearInterval(timer);
    }, []);

    const time = now.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    const date = now.toLocaleDateString(undefined, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });

    return (
        <div className="clock-widget">
            <div className="clock-widget__time" style={{ color: settings.color || '#111827' }}>{time}</div>
            <div className="clock-widget__date">{date}</div>
        </div>
    );
};

export default ClockWidget;
